import ABCyaPhaser from "@abcya/abcya_phaser";
import TextUtils from "@abcya/abcya_phaser/src/js/Utils/GameObjects/UI/TextUtils";
import Phaser from "phaser";
import NavBar from "../components/NavBar";
import FontKeys from "../FontKeys";
import gameData from "../gameData";
import SoundController, { playGameJingle } from "../SoundController";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";
import Game from "./Game";

const Constants = {
  COLS_NUM: 5,
  BUTTON_WIDTH: 105,
  BUTTON_TWEEN_DELAY: 25,
  BUTTON_TWEEN: 100,
  BAR_TWEEN: 250,
  BAR_DELAY: 500,
};

export default class Level extends Phaser.Scene {
  static get KEY() {
    return "Level";
  }

  preload() {
    // preload your assets here, if needed
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(
      0,
      0,
      UIAssetKeys._GameBackground,
      this
    );
    this.bg.setOrigin(0, 0);

    this.topBar = new NavBar(this);
    this.add.existing(this.topBar);
    this.topBar.enableLevelText(true);
    this.topBar.y = -100;

    this.bottomBar = ABCyaPhaser.Images.addImage(
      this.scale.width * 0.5,
      this.scale.height + 35,
      UIAssetKeys._UIBarBottom,
      this
    );

    this.topBar.setLevelText(
      Math.min(
        gameData.levelData.getTotalLevels(),
        gameData.levelData.getHighestUnlockedLevel() + 1
      ).toString(),
      gameData.levelData.getTotalLevels()
    );

    this.buttons = [];
    this.levelsContainer = this.add.container(
      this.scale.width * 0.5,
      this.scale.height * 0.5 + 20
    );
    this.levelsContainer.setScale(0.95);

    const levelsContainerWidth = Constants.BUTTON_WIDTH * Constants.COLS_NUM;
    const levelsContainerHeight =
      (Constants.BUTTON_WIDTH * gameData.levelData.getTotalLevels()) /
      Constants.COLS_NUM;

    for (let i = 0; i < gameData.levelData.getTotalLevels(); i++) {
      const finalX =
        -levelsContainerWidth * 0.5 +
        (i % Constants.COLS_NUM) * Constants.BUTTON_WIDTH +
        Constants.BUTTON_WIDTH * 0.5;
      const finalY =
        -levelsContainerHeight * 0.5 +
        Math.floor(i / Constants.COLS_NUM) * Constants.BUTTON_WIDTH +
        Constants.BUTTON_WIDTH * 0.5;

      const button = this.add.container(finalX, finalY);
      button.index = i;

      const locked = gameData.levelData.getLevelIsLocked(i);
      const buttonName = locked ? "LevelBtnLocked" : "LevelBtnCleared";
      if (i === gameData.levelData.getHighestUnlockedLevel()) {
        buttonName = "LevelBtn";
      }

      button.bg = ABCyaPhaser.Images.addImage(0, 0, buttonName, button);

      if (!locked) {
        button.setInteractive(
          new Phaser.Geom.Rectangle(0, 0, 500, 500),
          Phaser.Geom.Rectangle.Contains
        );
        const label = TextUtils.addText(
          0,
          0,
          36,
          0xffffff,
          FontKeys._nulshockbold,
          (i + 1).toString(),
          button,
          true
        );
      }
      this.levelsContainer.add(button);
      button.setScale(0);

      this.buttons.push(button);

      ABCyaPhaser.Tweens.addTween(
        button,
        Constants.BUTTON_TWEEN,
        {
          delay: i * Constants.BUTTON_TWEEN_DELAY,
          scaleX: 1,
          scaleY: 1,
        },
        Phaser.Math.Easing.Circular.In,
        () => {
          if (i === gameData.levelData.getTotalLevels() - 1) {
            this.enable();
          }
        }
      );
    }

    ABCyaPhaser.Tweens.addTween(
      this.bottomBar,
      Constants.BAR_TWEEN,
      {
        delay: Constants.BAR_DELAY,
        y: this.scale.height - this.bottomBar.height * 0.5,
      },
      Phaser.Math.Easing.Circular.Out
    );

    ABCyaPhaser.Tweens.addTween(
      this.topBar,
      Constants.BAR_TWEEN,
      {
        delay: Constants.BAR_DELAY,
        y: 0,
      },
      Phaser.Math.Easing.Circular.Out
    );

    SoundController.initScene(this);
  }

  enable() {
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      if (!gameData.levelData.getLevelIsLocked(button.index)) {
        button.bg.setInteractive({ cursor: "pointer" });
        button.bg.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, (e) => {
          gameData.levelData.setLevel(button.index, true);
          ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Click, this);
          this.disable();
          this.doOutTransitions();
        });
      }
    }
  }

  disable() {
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];
      button.bg.removeAllListeners();
    }
  }

  doOutTransitions() {
    ABCyaPhaser.Tweens.addTween(
      this.bottomBar,
      Constants.BAR_TWEEN,
      {
        y: this.scale.height + this.bottomBar.height * 0.5,
      },
      Phaser.Math.Easing.Circular.Out
    );

    ABCyaPhaser.Tweens.addTween(
      this.topBar,
      Constants.BAR_TWEEN,
      {
        y: -100,
      },
      Phaser.Math.Easing.Circular.Out
    );
    for (let i = 0; i < this.buttons.length; i++) {
      const button = this.buttons[i];

      ABCyaPhaser.Tweens.addTween(
        button,
        Constants.BUTTON_TWEEN,
        {
          delay: i * Constants.BUTTON_TWEEN_DELAY,
          scaleX: 0,
          scaleY: 0,
        },
        Phaser.Math.Easing.Circular.In,
        () => {
          if (i === gameData.levelData.getTotalLevels() - 1) {
            this.scene.start(Game.KEY);
          }
        }
      );
    }
  }
}
